import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";

/**
 * Apply this to any element that has a focus ring created with a ::before pseudoelement.
 * {@see createFocusRing} for more details.
 * TODO move this to createFocusRingStyles
 */
export const FOCUS_USING_BEFORE_CLASS_NAME = "lodestar--focus-using-before";

/**
 * Apply this to any element that has a focus ring created with a real
 * DOM element (as opposed to a ::before pseudoelement).
 * {@see createFocusRing} for more details.
 * TODO move this to createFocusRingStyles
 */
export const FOCUS_USING_ELEMENT_CLASS_NAME = "lodestar--focus-using-element";
const focusRingTheme = themed({
  color: color("color--border--surfaces--focus")
});

/**
 * @deprecated please use createFocusRingStyles instead.
 */
export const getFocusRingStyles = _ref => {
  let {
    colorOverride: color,
    theme,
    offset,
    radius: borderRadius,
    // TODO we should default this to true before we expose this.
    includeFocusPseudoClass = false,
    borderWidth = 2,
    position = "relative",
    pseudoElement = "before",
    focusSelector = "focus"
  } = _ref;
  return `
    & {
        position: ${position};
        outline: none;
    }

    &:${focusSelector} {
        outline: none;
    }

    &${includeFocusPseudoClass ? `:${focusSelector}` : ""}::${pseudoElement} {
        content: "";
        display: block;
        position: absolute;
        top: -${offset}px;
        right: -${offset}px;
        bottom: -${offset}px;
        left: -${offset}px;
        border: ${borderWidth}px solid ${color || focusRingTheme.color(theme)};
        border-radius: ${typeof borderRadius === "string" ? borderRadius : `${borderRadius}px`};
        pointer-events: none;
    }
`;
};
//# sourceMappingURL=focusRing.js.map